import { mapActions } from 'vuex'
// import _ from 'lodash'

import { APP_RESOURCE } from '@common/store/module-types'
import { GET_ENV_LIST } from '@common/store/app-resource/types'
import { getEvnZHName } from '@common/utils/zh'
import TreeSelect from '@common/components/common/tree-select'
import importDialog from '../component/import-dialog'

import commomMinxin from './commom'

const groupNameReg = /[^\u4E00-\u9FA5A-Za-z_]/g

export default {
    mixins: [commomMinxin],
    data() {
        return {
            envData: {}, // 环境类型
            businessEnvId: '',
            propsConfig: {                // 配置项（必选）
                value: 'value',
                label: 'label',
                children: 'children',
            },
            showImportDialog: false,
            requestDelay: false,
            groupNameReg,

        }
    },
    components: {
        TreeSelect,
        importDialog,
    },
    computed: {
        evnTypeTree() {
            return this.getEvnTypeTree()
        },
        treeConfig() {
            const {
                evnTypeTree, businessEnvId, propsConfig, initialEnvId,
            } = this
            return {
                evnTypeTree,
                propsConfig,
                initialEnvId,
                filterEvnTypeTree: this.getEvnTypeTree([businessEnvId]),
            }
        },
        isDevEnv() {
            // const { businessEnvId, envData: { dev = [] } } = this
            // return _.some(dev, item => item.id === businessEnvId)
            return true
        },
        initialEnvId() {
            return this.envData?.dev?.find(item => item.canDelete === 0)?.id ?? ''
        },
    },
    mounted() {
        this.onChangeBusinessEnvId && this.onChangeBusinessEnvId()
        // 取消调用环境详情接口
        // !this.requestDelay && this.getAllEnvList()
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getEnvList: GET_ENV_LIST,
        }),

        getEvnTypeTree(filterEnvTypeIds = []) {
            const tree = []
            const { envData } = this
            Object.keys(envData).forEach(key => {
                const children = envData[key].filter(item => !filterEnvTypeIds.includes(item.id)).map(item => ({
                    label: item.name,
                    value: item.id,
                    category: item.category,
                }))
                tree.push({
                    label: getEvnZHName(key),
                    children,
                })
            })
            return tree
        },

        async getAllEnvList() {
            const { $to } = this
            const { appId } = this.$route.params
            const params = {
                appId,
            }
            const [err, data] = await $to(this.getEnvList(params))
            if (!err) {
                this.envData = data
                // TODO-RN 初始化的值更新
                this.businessEnvId = ''
                const envs = ['dev', 'test', 'beta', 'prod']
                let envValue = data.dev
                for (let i = 0; i < envs.length; i++) {
                    const env = envs[i]
                    if (data[env].length > 0) {
                        envValue = data[env]
                        break
                    }
                }
                this.getAllEnvListCallBack && this.getAllEnvListCallBack(envValue)
            }
        },

        // 获取环境选择输入框内容
        getValue(businessEnvId) {
            // TODO-RN:如何在请求传递参数
            this.businessEnvId = businessEnvId
        },

        closeImportDialog() {
            this.showImportDialog = false
        },
    },
}
